import React from 'react'
import SendInvites from './SendInvites'

import PendingInvites from './PendingInvites'
import EventListener from '../../../utils/EventListener'
import { Container, Top } from '../styles'
import { DefaultUserPage } from '../../DefaultPages'
import { Breadcrumbs } from '../../../components'
import { Description } from './styles'
import UserList from './UserList'

const Users = () => {
  const usersEventListener = new EventListener()

  return (
    <DefaultUserPage page="users">
      <Container>
        <Top>
          <Breadcrumbs />
        </Top>
        <Description>
          Aqui você pode convidar usuários para gerenciar os certificados
        </Description>
        <SendInvites eventListener={usersEventListener} />
        <PendingInvites eventListener={usersEventListener} />
        <UserList eventListener={usersEventListener} />
      </Container>
    </DefaultUserPage>
  )
}

export default Users
